export const DIESEL = "diesel";
export const PETROL = "petrol";
export const ELECTRIC = "electric";
export const NOT_APPLICABLE = "not-applicable";
